<div class="flex flex-col w-full">
  @if (isLoading()) {
  <div class="animate-pulse flex flex-col gap-3 p-2">
    <div class="h-4 bg-secondary-border rounded w-1/3"></div>
    <div class="h-24 bg-secondary-border rounded w-full"></div>
  </div>
  } @else if (isRelationsLoading()) {
  <div class="animate-pulse flex flex-col gap-3 p-2">
    <div class="h-4 bg-secondary-border rounded w-1/4 mb-2"></div>
    <div class="h-12 bg-secondary-border rounded w-full"></div>
    <div class="h-12 bg-secondary-border rounded w-full"></div>
    <div class="text-secondary-text text-sm italic mt-2">Loading relations config...</div>
  </div>
  } @else {

  @if (data().length === 0) {
  <div class="mb-4 bg-info/10 border border-info/20 text-info px-4 py-3 rounded-md flex items-center gap-2 shadow-sm">
    <i class="fas fa-info-circle text-lg"></i>
    <span class="font-medium">{{ localTexts.noData }}</span>
  </div>
  }

  @if (recordIds && recordIds.length > 0) {
  <div class="mb-4 bg-info/10 border border-info/20 text-info px-4 py-3 rounded-md flex items-center gap-2 shadow-sm">
    <i class="fas fa-info-circle text-lg"></i>
    <span class="font-medium">{{ localTexts.specificRecordsInfo }} ({{ recordIds.length }})</span>
  </div>
  }

  <div class="mb-4 w-full overflow-hidden">
    <rapider-list-grid [config]="mainGridConfig()"
                       [data]="data()"
                       [enableRowPointer]="true"
                       [selectAndMark]="true"
                       (rowActionClick)="onRowClick($event)"
                       (itemMouseEnter)="onRowMouseEnter($event)"
                       (itemMouseLeave)="onRowMouseLeave()">
    </rapider-list-grid>
  </div>

  @if (!recordIds || recordIds.length === 0) {
  <div class="mb-6 flex justify-end w-full border-t border-secondary-border pt-3">
    <nz-pagination [nzPageIndex]="currentPage()"
                   [nzTotal]="totalItems()"
                   [nzPageSize]="pageSize()"
                   (nzPageIndexChange)="onPageChange($event)">
    </nz-pagination>
  </div>
  }

  @if (activeDisplayRecord(); as rec) {

  <div *ngIf="rec"
       class="mb-4 w-full">
    <rapider-data-card [projectModelName]="projectModelName"
                       [data]="rec"
                       [diffClassMap]="diffClassMap()"></rapider-data-card>
  </div>

  @if (model()?.relations; as relations) {
  <div class="flex flex-col gap-4 bg-alt-bold-background border border-primary-border rounded-lg p-4">
    @for (rel of relations; track rel.name; let isFirst = $first) {
    @if (rec[rel.name] !== undefined && rec[rel.name] !== null) {
    @if (!isFirst) {
    <nz-divider class="my-2 border-secondary-border"></nz-divider>
    }
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <i class="fas fa-link text-info"></i>
        <span class="font-bold text-primary-text">{{ getTargetModelTitle(rel.targetModel?.title || rel.targetModel?.name
          || rel.name, cachedModels()) }}</span>
        <nz-tag class="!m-0 bg-info/10 text-info border-info/20">{{ rel.name }}</nz-tag>
      </div>

      <div class="bg-component-inner rounded-lg border border-secondary-border p-2 shadow-sm overflow-hidden">
        @if (getRelationDisplayType(rel.type, rec[rel.name]) === 'grid') {
        <rapider-list-grid [config]="getGridConfigForModel(rel.targetModel?.name || rel.name, cachedModels(), normalizeDataAsArray(rec[rel.name]))"
                           [data]="normalizeDataAsArray(rec[rel.name])">
        </rapider-list-grid>
        } @else {
        <rapider-json-viewer [data]="rec[rel.name]"
                             [maxLineToDisplay]="10"
                             class="w-full">
        </rapider-json-viewer>
        }
      </div>
    </div>
    } @else {
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <i class="fas fa-link text-info"></i>
        <span class="font-bold text-primary-text">{{ getTargetModelTitle(rel.targetModel?.title || rel.targetModel?.name
          || rel.name, cachedModels()) }}</span>
        <nz-tag class="!m-0 bg-info/10 text-info border-info/20">{{ rel.name }}</nz-tag>
      </div>
      <div class="text-secondary-text text-sm italic p-2 flex items-center gap-2">
        <i class="fas fa-info-circle"></i> {{ localTexts.noData }}
      </div>
    </div>
    }
    }
  </div>
  }
  }
  }
</div>